module.exports = {"430221100":"渌口镇","430221101":"朱亭镇","430221106":"古岳峰镇","430221107":"淦田镇","430221108":"龙门镇","430221109":"龙潭镇","430221110":"南洲镇","430221111":"龙船镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430221.json
// module id = 1943
// module chunks = 0